import React, { useState } from 'react';
import "./styles.scss";

const EditTypeModal = ({
  isOpen,
  typeBeingEdited,
  valueBeingEdited,
  editedTypeName,
  editedValueName,
  editedValue,
  editedIsAvailable,
  handleEditTypeNameChange,
  handleEditValueNameChange,
  handleEditValueChange,
  handleEditIsAvailableChange,
  handleSaveEditedType,
  handleSaveEditedValue,
  handleCloseEditTypeModal,
  handleBackFromEditTypeModal,
  handleOpenAddNewTypeModal,
  kudosTypes,
  editType,
  handleDeleteType,
  toggleExpandType,
  expandedTypeId,
  handleOpenAddNewValueModal,
  kudosTypesValues,
  editValueType,
  handleDeleteValueType,
}) => {
  const [initialTypeName, setInitialTypeName] = useState(null);
  const [initialValueName, setInitialValueName] = useState(null);
  const [initialValue, setInitialValue] = useState(null);
  const [initialIsAvailable, setInitialIsAvailable] = useState(null);
  const [selectedKudosType, setSelectedKudosType] = useState(null);

  const handleEditButtonClick = (typeId, valueId) => {
    if (typeId) {
      const type = kudosTypes.find(t => t.id === typeId);
      setInitialTypeName(type.name);
      editType(typeId);
    } else if (valueId) {
      const value = kudosTypesValues.find(v => v.id === valueId);
      setInitialValueName(value.name);
      setInitialValue(value.value);
      setInitialIsAvailable(value.isAvailable);
      editValueType(valueId);
    }
  };

  const handleReset = () => {
    if (typeBeingEdited) {
      handleEditTypeNameChange({ target: { value: initialTypeName } });
    } else if (valueBeingEdited) {
      handleEditValueNameChange({ target: { value: initialValueName } });
      handleEditValueChange({ target: { value: initialValue } });
      handleEditIsAvailableChange({ target: { value: initialIsAvailable ? "active" : "archived" } });
    }
  };

  const handleToggleExpandType = (typeId) => {
    const type = kudosTypes.find(t => t.id === typeId);
    setSelectedKudosType(type);
    toggleExpandType(typeId);
  };

  if (!isOpen) return null;

  return (
    <div
      id="editTypeModal"
      className="modal fade in example-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-title-2"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              onClick={handleCloseEditTypeModal}
              className="close"
              aria-label="Close"
            >
              &times;
            </button>
            <h4 id="modal-title-2" className="modal-title">
              Edit Types/Type Values
            </h4>
          </div>
          <div className="modal-body">
            {typeBeingEdited ? (
              <div className="form-group">
                <label htmlFor="editedTypeName" className="col-xl-4 col-sm-5 col-xs-5 control-label">
                  Type Name:
                </label>
                <div className="col-xl-8 col-sm-7 col-xs-7">
                  <input
                    id="editedTypeName"
                    type="text"
                    value={editedTypeName}
                    onChange={handleEditTypeNameChange}
                    className="form-control"
                  />
                </div>
              </div>
            ) : valueBeingEdited ? (
              <div>
                <div className="form-group">
                  <label htmlFor="editedValueName" className="col-xl-4 col-sm-5 col-xs-5 control-label">
                    Value Name:
                  </label>
                  <div className="col-xl-8 col-sm-7 col-xs-7">
                    <input
                      id="editedValueName"
                      type="text"
                      value={editedValueName}
                      onChange={handleEditValueNameChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="editedValue" className="col-xl-4 col-sm-5 col-xs-5 control-label">
                    Value:
                  </label>
                  <div className="col-xl-8 col-sm-7 col-xs-7">
                    <input
                      id="editedValue"
                      type="number"
                      value={editedValue}
                      onChange={handleEditValueChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="editedIsAvailable" className="col-xl-4 col-sm-5 col-xs-5 control-label">
                    Status:
                  </label>
                  <div className="col-xl-8 col-sm-7 col-xs-7">
                    <select
                      id="editedIsAvailable"
                      value={editedIsAvailable ? "active" : "archived"}
                      onChange={handleEditIsAvailableChange}
                      className="form-control"
                    >
                      <option value="active">Active</option>
                      <option value="archived">Archived</option>
                    </select>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <button
                  className="btn btn-primary"
                  onClick={handleOpenAddNewTypeModal}
                >
                  Add New Type
                </button>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {kudosTypes.map((type) => (
                      <React.Fragment key={type.id}>
                        <tr>
                          <td>{type.name}</td>
                          <td>
                            <div className="action-buttons">
                              <span
                                aria-hidden="true"
                                className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-edit mr-8"
                                onClick={() => handleEditButtonClick(type.id, null)}
                              ></span>
                              {process.env.REACT_APP_FEATURE_DELETE_TYPE_VALUES_AND_PRODUCTS === "true" && (
                                <span
                                  aria-hidden="true"
                                  className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-delete mr-8"
                                  onClick={() => handleDeleteType(type.id)}
                                ></span>
                              )}
                              <button className="btn" onClick={() => handleToggleExpandType(type.id)}>
                                {expandedTypeId === type.id ? "Hide Values" : "Show Values"}
                              </button>
                            </div>
                          </td>
                        </tr>
                        {expandedTypeId === type.id && (
                          <tr>
                            <td colSpan="2">
                              <button className="btn btn-primary" onClick={() => handleOpenAddNewValueModal(selectedKudosType)}>
                                Add New Value
                              </button>
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Value Name</th>
                                    <th>Value</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {kudosTypesValues
                                    .filter((value) => value.requestKudosTypeId === type.id)
                                    .map((value) => (
                                      <tr key={value.id}>
                                        <td>{value.name}</td>
                                        <td>{value.value}</td>
                                        <td>
                                          <span className={`label label-${value.isAvailable ? 'success' : 'warning'}`}>
                                            {value.isAvailable ? 'Active' : 'Archived'}
                                          </span>
                                        </td>
                                        <td>
                                          <div className="action-buttons">
                                            <span
                                              aria-hidden="true"
                                              className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-edit mr-8"
                                              onClick={() => handleEditButtonClick(null, value.id)}
                                            ></span>
                                            {process.env.REACT_APP_FEATURE_DELETE_TYPE_VALUES_AND_PRODUCTS === "true" && (
                                              <span
                                                aria-hidden="true"
                                                className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-delete mr-8"
                                                onClick={() => handleDeleteValueType(value.id)}
                                              ></span>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="modal-footer">
            {typeBeingEdited || valueBeingEdited ? (
              <>
                <button className="btn btn-primary" onClick={typeBeingEdited ? handleSaveEditedType : handleSaveEditedValue} disabled={!editedValueName.trim() || Number(editedValue) <= 0}>
                  Save
                </button>
                <button className="btn btn-secondary" onClick={handleReset}>
                  Reset
                </button>
                <button className="btn" onClick={handleBackFromEditTypeModal}>
                  Back
                </button>
              </>
            ) : (
              <button className="btn" onClick={handleCloseEditTypeModal}>
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTypeModal;